const ROLES = ["FEEDBACK-ADMIN", "HR", "PROJECT MANAGER", "IT SUPPORT"];

const TICKET_STATUS = {
  OPEN: "0",
  CLOSE: "1",
  INITIAL: "2",
  INPROGRESS: "3",
  FINAL: "4",
  NEED_INFO:"5"
};

// This status code refer to TICKET_STATUS
let SEND_STATUS_OPTIONS = [
  { label: "Initial", value: "2" },
  // { label: "Follow up", value: "3" },
  { label: "Final", value: "4" },
  { label: "Need info", value: "5" },
];

const TICKET_PROGRESS_STATUS = {
  PENDING: "0",
  ASSIGNED: "1",
  CANCELLED: "2",
  REASSIGNED: "4",
};

const TICKET_TYPE_STATUS = {
  PENDING: "1",
  ASSIGNED: "2",
};


const MODE_STATUS = {
  DIRECT: "0",
  MAIL: "1",
  QR: "2",
};

const EMAIL_STATUS = {
  PENDING: "0",
  SEND: "1",
  REPLY: "4",
  FAILED: "3",
};

const PRIORITY = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

const STATUS = {
  TODO: 1,
  INPROGRESS: 2,
  COMPLETED: 3,
  NOTASSIGNED: 4,
  STAGING: 5,
  PENDING: 6,
  UAT: 7,
};

// ─── Todo Task statuses (taskManagementVer2) ──────────────────────────────────
const TASK_STATUS = {
  TODO: 1,
  INPROGRESS: 2,
  COMPLETED: 3,
  NOTASSIGNED: 4,
  ACKNOWLEDGE: 5,
  REWORK_REQUIRED: 6,
  HOLD: 7,
  DUPLICATE: 8,
};

// Assignee privacy is ON by default: a new task hides the roster, and sharing
// it is the deliberate act. Mirrors the `default: true` on privateAssignees in
// the backend's model/taskManagementVer2.js and model/recurringTemplate.js —
// keep the two in sync. Every create form seeds its toggle from this.
const DEFAULT_PRIVATE_ASSIGNEES = true;

const ISSUETYPE = {
  TASK: 1,
  BUG: 2,
  MEETING: 3,
  TESTING: 4,
  DESIGNING: 5,
  OTHERS: 6,
  DEPLOYMENT: 7,
};

const VERIFY_STATUS = {
  PENDING: 0,
  REOPEN: 1,
  COMPLETED: 2,
};

export {
  ROLES,
  TICKET_STATUS,
  SEND_STATUS_OPTIONS,
  TICKET_PROGRESS_STATUS,
  TICKET_TYPE_STATUS,
  MODE_STATUS,
  EMAIL_STATUS,
  PRIORITY,
  STATUS,
  TASK_STATUS,
  DEFAULT_PRIVATE_ASSIGNEES,
  ISSUETYPE,
  VERIFY_STATUS,
};
